var CatalogCtrl = function CatalogCtrl() {};

export default CatalogCtrl;